import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListKebutuhanKhusus } from "@/services/getData"

export default function MasterKebutuhanKhusus() {
  const { data, isPending } = useQuery({
    queryKey: ["listKebutuhanKhusus"],
    queryFn: getListKebutuhanKhusus,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
